import { useEffect, useState, useRef } from 'react';
import { marketBoardApi } from './api';

/**
 * Polls the calciomercato board unread-count every 60 seconds while the tab
 * is visible. Lightweight: returns a plain `{count}` so the sidebar / header
 * can render a simple badge.
 */
export default function useMarketBoardUnread(user) {
  const [count, setCount] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    if (!user) {
      setCount(0);
      return;
    }
    let cancelled = false;

    const fetchOnce = async () => {
      try {
        const res = await marketBoardApi.unreadCount();
        if (!cancelled) setCount(res.data?.unread_count || 0);
      } catch {
        /* network errors are non-fatal — badge just won't update */
      }
    };

    fetchOnce();
    timerRef.current = setInterval(() => {
      if (document.visibilityState === 'visible') fetchOnce();
    }, 60000);

    const onVis = () => { if (document.visibilityState === 'visible') fetchOnce(); };
    document.addEventListener('visibilitychange', onVis);

    return () => {
      cancelled = true;
      if (timerRef.current) clearInterval(timerRef.current);
      document.removeEventListener('visibilitychange', onVis);
    };
  }, [user]);

  return { count };
}
